export default "__VITE_ASSET__Cnbe66ut__"